import { RefObject, useEffect, useMemo, useRef } from 'react';

type OutsideRef = RefObject<HTMLElement | null>;

const isPathInsideRefs = (path: EventTarget[], refs: OutsideRef[]): boolean =>
  refs.some((ref) => ref.current !== null && path.includes(ref.current));

export const useClickOutside = (
  refs: OutsideRef | OutsideRef[],
  onClickOutside: () => void,
  isActive: boolean,
): void => {
  const callbackRef = useRef(onClickOutside);

  useEffect(() => {
    callbackRef.current = onClickOutside;
  }, [onClickOutside]);

  const watchedRefs = useMemo(() => (Array.isArray(refs) ? refs : [refs]), [refs]);

  useEffect(() => {
    if (!isActive) return undefined;

    const handlePointerDown = (event: PointerEvent): void => {
      if (isPathInsideRefs(event.composedPath(), watchedRefs)) return;
      callbackRef.current();
    };

    document.addEventListener('pointerdown', handlePointerDown, true);
    return () => document.removeEventListener('pointerdown', handlePointerDown, true);
  }, [watchedRefs, isActive]);
};